<h2 mat-dialog-title mat-dialog-content cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandl>Confirmación</h2>
<div mat-dialog-content>
    <p style="white-space: pre-line">{{message}}</p>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="closeDialog()">No</button>
    <button color="primary" mat-flat-button (click)="confirm()" cdkFocusInitial>Sí</button>
</div>
